import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orders"},[_c(VCard,[_c(VCardTitle,[(_vm.canCreateOrders)?_c(VBtn,{attrs:{"color":"primary","dark":"","text":""},on:{"click":function($event){return _vm.goToNewOrder()}}},[_c(VIcon,{attrs:{"left":""}},[_vm._v("add_circle")]),_vm._v("\n        Add new\n      ")],1):_vm._e(),_c(VSpacer),_c('order-filters')],1),_c(VCardText,[_c('OrderTable',{attrs:{"expandedOrderUuid":_vm.expandedOrderUuid}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }